import { React, createRef, Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import "./nav-menu.component.css";
import Header from "../header-navigation/header/header.component";
import NavMainMenu from "./nav-main-menu.component";
import { showApprovalNotif } from "../../../utils/helpers.utils";
import { navMenuActions } from '../../../store/external/nav-menu-reducer/nav-menu.reducer'

class NavMenu extends Component {
    constructor(props) {
        super();
        this.ref = createRef();
    }

    checkIfClickedOutside = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target)) {
            var mainNav = document.querySelectorAll(".isActive");
            for (let i = 0; mainNav.length > i; i++) {
                mainNav[i].classList.remove("isActive");
            }
        }
    }

    async componentDidMount() {
        await this.props.setSubsUnderLM();
        await this.props.fetchNavItems();
        await this.props.fetchBurgerMenuUrls();
        await this.props.fetchNewNavItems();
        window.addEventListener('mousedown', this.checkIfClickedOutside)
    }

    async componentDidUpdate(prevProps) {
        if (this.props.isUserLoggedIn !== prevProps.isUserLoggedIn) {
            await this.props.setSubsUnderLM();
            await this.props.fetchNavItems();
            await this.props.fetchBurgerMenuUrls();
            await this.props.fetchNewNavItems();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkIfClickedOutside)
    }

    render() {
        const { newNavItems, isUserLoggedIn, isChatOpen } = this.props;
        let showNotif = showApprovalNotif();
        return (
            <div>
                <nav className={`external-nav ${isChatOpen ? 'is-chat-open' : ''}`}
                 ref={this.ref}                 
                >
                    <Header isUserLoggedIn={isUserLoggedIn}></Header>
                    { newNavItems.length > 0 &&
                        <NavMainMenu navMenu={newNavItems} showNotif={showNotif}/>
                    }
                </nav>
            </div>
        );
    }
}

export default connect(
    state => state.navMenu,
    dispatch => bindActionCreators(navMenuActions, dispatch),
    null,
    {
        pure: false
    }
)(NavMenu);